<template>
    <div>

        <v-flex text-xs-center mt-5 v-if="!selectedTrip">
            Select a trip on the map first !
        </v-flex>

        <v-flex mt-3 v-if="selectedTrip">
            <vs-tabs>
                <vs-tab vs-label="1. Upload your photos">
                    <div class="con-tab-ejemplo">
                        <ic-firebase-uploader
                                v-bind:path="getFolderPath"
                                max-files="11234"
                                :getFileName="getFileName"
                                :storage="getStorage()"
                                @upload="onUpload"
                                @uploaded="onUploaded"
                                @delete="onDelete">
                        </ic-firebase-uploader>

                        <!--<button @click="handleAlbumReload()">handleAlbumReload()</button>-->


                        <div v-if="selectedImagesCount">
                            Selected images : {{selectedImagesCount}}
                        </div>

                        <b-button
                                 variant="danger"
                                   @click="openConfirmDelete()"
                                   v-bind:disabled="selectedImagesCount===0">
                            Delete {{ selectedImagesCount}} images
                        </b-button>

                        <!-- MULTIPLE SELECTION -->
                        <vue-select-image :dataImages="albumImagesBaseURL()"
                                          :is-multiple="true"
                                          :selectedImages="initialSelected"
                                          @onselectmultipleimage="onSelectMultipleImage">
                        </vue-select-image>


                    </div>
                </vs-tab>
                <vs-tab vs-label="2. Select known locations">
                    <div class="con-tab-ejemplo">
                        <h1>{{ imageWithGPSCount }} / {{ imageCount}} Photos with GPS Info</h1>

                        <vue-select-image :dataImages="albumImagesWithGPS()"
                                          :is-multiple="false">
                        </vue-select-image>
                    </div>
                </vs-tab>

                <vs-tab vs-label="3. Add Missing locations">
                    <h1>{{ imageCount - imageWithGPSCount }} / {{ imageCount}} Photos WITHOUT GPS Info</h1>


                    <div class="con-tab-ejemplo">


                    </div>
                </vs-tab>

            </vs-tabs>
        </v-flex>


        <div class="alert alert-danger" v-if="error">
            <button type="button" aria-hidden="true" class="close">×</button>
            <span>{{error}}</span>
        </div>
    </div>
</template>

<script>
  import firebase from 'firebase'

  const fb = require('../firebaseConfig.js')

  /////////////
  import Vue from 'vue'

  import IcFirebaseUploader from 'ic-firebase-uploader'
  import 'ic-firebase-uploader/dist/ic-firebase-uploader.min.css'
  import { mediasCollection } from '../firebaseConfig'

  Vue.component('ic-firebase-uploader', IcFirebaseUploader)
  /////////////////
  import gmapsInit from '../googleMapsConfig'

  /////////////////
  import UIHelpersMixins from '../mixims/UIHelpersMixins'

  export default {
    mixins:
      [
        UIHelpersMixins,
      ],
    data ()
    {
      return {
        alert:             '',
        openConfirmActive: false,

        initialSelected: [],
        albumImages:     [],

        selectedImages:     [],
        albumImagesGPS:     [],
        initialSelectedGPS: [],

        // Set pos tab
        openLocalisationActive: false,
        albumImagesWithoutGPS:  [],
        selectImageAddPosition: null,

      }
    },
    mounted:  function () {

      gmapsInit().then(function () {
      })

          this.handleAlbumReload()
    },
    methods:  {
      getStorage ()
      {
        return firebase.storage()
      },
      openConfirmDelete ()
      {
        this.$vs.dialog({
          type:   'confirm',
          color:  'danger',
          title:  `Confirm`,
          text:   'Are you sure you want to delete ' + this.selectedImages.length + ' images ?',
          accept: this.acceptConfirmDelete
        })
      },
      acceptConfirmDelete (color)
      {
        var that = this
        this.selectedImages.forEach(function (k, v) {

          fb.mediasCollection.doc(k.id).get().then(function (doc) {

            if (!doc.exists)
            {
              return
            }

            fb.storage.ref().child(doc.data().fullPath).delete().then(function () {

            }).catch(function (error) {

            })

            if (doc.data().thumbsPath)
            {
              for (var k in doc.data().thumbsPath)
              {
                var path = doc.data().thumbsPath[k]

                fb.storage.ref().child(path).delete().then(function () {

                }).catch(function (error) {

                })
              }
            }

            if (1)
            {
              fb.mediasCollection.doc(doc.id).delete()
                .then(ref => {
                  that.$vs.notify({
                    color: 'success',
                    title: 'Deleted image',
                    text:  'The selected image was successfully deleted'
                  })
                }).catch(err => {
                that.$vs.notify({title: 'Error!', text: err, color: 'danger'})

                that.selectedImages = []
                console.log(err)
              })
            }

          })

        })

        this.selectedImages = []
      },
      getFileName (file)
      {
        return file.name + '_' + Math.floor(Math.random() * 1000 * 1000)
      },
      onUpload ({fullPath, file, doUpload})
      {
        fb.mediasCollection.add({
          createdOn: new Date(),
          updatedOn: new Date(),
          metadata:  {
            lastModified: file.lastModifiedDate,
            name:         file.name,
            size:         file.size,
            type:         file.type,
          },
          // storageId:   id,
          fullPath:  fullPath,
          // downloadUrl: getDownloadURL,
          uid:       this.currentUser.uid,
          tripId:    this.selectedTrip.id,

        }).then(ref => {

          doUpload({
            ourFile: file,
            docID:   ref.id,
          })

        }).catch(err => {
          this.$vs.notify({title: 'Error!', text: err, color: 'danger'})

          console.log(err)
        })

      },
      onUploaded ({id, fullPath})
      {
        var file  = id.ourFile
        var docID = id.docID

        fb.mediasCollection.doc(docID).update
        ({
          updatedOn: new Date(),
          status:    'Uploaded :)',

        }).then(ref => {
          this.$vs.notify({title: fullPath + ' Added!', color: 'success'})
        }).catch(err => {
          this.$vs.notify({title: 'Error!', text: err, color: 'danger'})

          console.log(err)
        })
      },
      onDelete ({doDelete})
      {
        doDelete()
      },

      handleAlbumReload ()
      {
        if (!this.selectedTrip)
        {
          return
        }
        var that = this

        fb.mediasCollection.where('tripId', '==', this.selectedTrip.id).orderBy('capturedOn', 'asc')
          .onSnapshot(function (querySnapshot) {

            that.albumImages           = []
            that.albumImagesGPS        = []
            that.albumImagesWithoutGPS = []

            querySnapshot.forEach(function (doc) {

              var data = doc.data()
              if (data.thumbsPath)
              {
                var img = {
                  id:         doc.id,
                  src:        data.thumbsPath[256],
                  alt:        data.metadata.name,
                  latitude:        data.metadata.latitude,
                  longitude:        data.metadata.longitude,
                  capturedOn: data.capturedOn,
                }

                that.albumImages.push(img)

                if (data.metadata.latitude &&
                  data.metadata.longitude)
                {
                  that.albumImagesGPS.push(img)
                }
                else
                {
                  that.albumImagesWithoutGPS.push(img)
                }
              }

            })

          })
      },
      onSelectMultipleImage (selectedImages)
      {
        this.selectedImages = selectedImages
      },

      albumImagesBaseURL ()
      {
        return this.albumImages
      },
      albumImagesWithGPS ()
      {
        return this.albumImagesGPS
      },

      imagesWithoutGPS ()
      {
        return this.albumImagesWithoutGPS
      },

    }, // methods
    computed: {
      currentUser()
      {
        return this.$store.getters.currentUser

      },

      selectedTrip()
      {
        return this.$store.getters.selectedTrip
      },

      getFolderPath ()
      {
        return 'trips/' + this.selectedTrip.id + '/medias'
      },

      isAuthenticated ()
      {
        return this.$store.getters.isAuthenticated
      },

      error ()
      {
        return this.$store.state.error
      },
      loading ()
      {
        return this.$store.state.loading
      },
      selectedImagesCount ()
      {
        return this.selectedImages.length
      },
      imageCount ()
      {
        return this.albumImages.length
      },
      imageWithGPSCount ()
      {
        return this.albumImagesGPS.length
      },
    },
    watch:    {

      selectedTrip: function () {
        console.log('WATCH: selectedTrip')
        this.handleAlbumReload()
      },
    }
  }
</script>